import React from "react";
import { HeaderModule } from '../../../components/home/HeaderModule';
import { HelpOutlineOutlined } from "@mui/icons-material";
import { ActionsBar } from "../../../components/ActionsBar";
import { TableModule } from "../../../components/home/TableModule";
import { useQuestions } from "../../../hooks/encuestas/useQuestions";

export const Questions = () => {

    const { columns, questions, addQuestion, searchQuestion } = useQuestions();

    return (
        <>
            <HeaderModule 
                icon={ <HelpOutlineOutlined htmlColor="rgba(0, 0, 0, .6)" /> }
                title='Preguntas'
            />

            <ActionsBar 
                addAction={ addQuestion }
                module='preguntas' 
                searchAction={ searchQuestion } 
                searchPlaceholder='Código' 
            />

            <TableModule
                columns={ columns }
                rows={ questions }
                styles={{
                    background: '#fff',
                    borderRadius: 6,
                    marginTop: 10,
                }}
            />
        </>
    )
};